import { AppState } from './shared/app-state.container';
import { SharedContainer } from './shared/shared.container';
import { SharedModule } from './shared/components/shared.module';
import { BrowserModule, Title, HAMMER_GESTURE_CONFIG, HammerModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppComponent } from './app.component';
import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleGlobalSiteTag } from 'angulartics2/gst';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';

import { TestComponent } from './test/test.component';

import { environment } from '../environments/environment';
import { Router, RouterModule, Routes } from '@angular/router';
import { SearchModule } from './modules/search/search.module';
import { DashboardModule } from './modules/dashboard/dashboard.module';
import { ResultsModule } from './modules/results/results.module';
import { BookingModule } from './modules/booking/booking.module';
import { VillaCollectionModule } from './modules/villa-collection/villa-collection.module';
import { PrivacyComponent } from './shared/components/privacy/privacy.component';
import { NotFoundComponent } from './shared/components/not-found/not-found.component';
import { AboutUsComponent } from './shared/components/about-us/about-us.component';
import { ContactUsComponent } from './shared/components/contact-us/contact-us.component';
import { ScriptService } from './core/services/script.service';
import { ApplicationFormComponent } from './shared/components/application-form/application-form.component';
import { GestureConfig } from '../gesture-config';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import { ScriptLoader } from './shared/components/scriptLoader';
import { NgxHotjarModule, NgxHotjarRouterModule } from 'ngx-hotjar';
import { NgxSpinnerModule } from 'ngx-spinner';
import {MatSnackBarModule} from '@angular/material/snack-bar';


const routes: Routes = [
  {
    path: '',
    redirectTo: '/search',
    pathMatch: 'full'
  },
  {
    path: 'results',
    redirectTo: '/results'
  },
  {
    path: 'my-dashboard',
    redirectTo: '/my-dashboard'
  },
  {
    path: 'booking',
    redirectTo: '/booking'
  },
  {
    path: 'villa-collection',
    redirectTo: '/villa-collection'
  },
  { path: 'privacy', component: PrivacyComponent },
  { path: '404', component: NotFoundComponent },
  { path: 'about-us', component: AboutUsComponent },
  { path: 'contact-us', component: ContactUsComponent },
  { path: 'application-form/:lang', component: ApplicationFormComponent },
  { path: '**', redirectTo: '/404' }
];
@NgModule({
  declarations: [
    AppComponent,
    TestComponent
  ],
  imports: [
    HttpClientModule,
    RouterModule.forRoot(routes),
    BrowserModule,
    FormsModule,
    SearchModule,
    DashboardModule,
    VillaCollectionModule,
    ResultsModule,
    BookingModule,
    SharedModule,
    BrowserAnimationsModule,
    NgxSpinnerModule,
    Angulartics2Module.forRoot({
      pageTracking: {
        clearQueryParams: true,
      },
      gst: {
        trackingIds: ['UA-45299324-1']
      },
    }),
    NgMultiSelectDropDownModule.forRoot(),
    SweetAlert2Module.forRoot(),
    HammerModule,
    MatPasswordStrengthModule.forRoot(),
    NgxHotjarModule.forRoot('2227361'),
    NgxHotjarRouterModule,
    MatSnackBarModule
  ],
  providers: [SharedContainer, ScriptLoader, Title, AppState, ScriptService, { provide: HAMMER_GESTURE_CONFIG, useClass: GestureConfig }],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(angulartics: Angulartics2GoogleGlobalSiteTag) {
    if (environment.production) {
      angulartics.startTracking();
    }
  }
}
